import { resolveTheme } from '../../designTokens';

export default function Card({ theme, children, onClick, style }) {
  const t = theme || resolveTheme();
  const base = {
    background: t.card_bg,
    border: `1px solid ${t.card_border}`,
    borderRadius: t.card_radius,
    boxShadow: t.card_shadow,
    overflow: 'hidden',
    ...style,
  };

  if (!onClick) {
    return <div style={base}>{children}</div>;
  }

  function handleEnter(e) {
    e.currentTarget.style.background = t.accent + '0d';
    e.currentTarget.style.borderColor = t.accent + '40';
  }
  function handleLeave(e) {
    e.currentTarget.style.background = t.card_bg;
    e.currentTarget.style.borderColor = t.card_border;
  }

  return (
    <div
      onClick={onClick}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{ ...base, cursor: 'pointer', transition: 'background 0.12s, border-color 0.12s' }}
    >
      {children}
    </div>
  );
}
